import {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';

class ScrollToTop extends Component<RouteComponentProps> {
  public componentDidUpdate(prevProps: any) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  public render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
